var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"chooser",class:{
    'chooser-no-margin': _vm.noMargin,
  }},[(_vm.label)?_c('label',{staticClass:"chooser-title"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('v-radio-group',{attrs:{"row":""}},_vm._l((_vm.items),function(item,index){return _c('v-radio',{key:index,class:{
        'v-item--active': _vm.value === item.value,
        'v-radio-two': _vm.twoItems,
      },attrs:{"label":item.label,"value":item.value},on:{"click":function($event){return _vm.changeValue(item.value)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }